import { IDreamItemProps } from '../../../components/ProfitItem';
import * as React from 'react';
import { trackButtonClick } from '../utils/tracking';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { useSelector } from 'react-redux';
import { selectMyHomeId } from '../../../selectors/selectMyHomeId';

export const useDreamProps = (): IDreamItemProps => {
  const isDesktop = useIsDesktop();

  const myHomeId = useSelector(selectMyHomeId);

  const handleClick = React.useCallback(() => {
    trackButtonClick('goSellToBuy');

    const linkStr = `https://www.cian.ru/my-home-dream/?myHomeId=${myHomeId}`;
    window.open(linkStr, '_blank');
  }, []);

  return {
    isDesktop,
    onButtonClick: handleClick,
  };
};
